import { SimpleGrid } from '@chakra-ui/react';
import SelectAvatarStyleInput from 'components/common/forms/SelectAvatarStyleInput';
import {
  TOP_STYLES,
  ACCESSORIES,
  HAIR_COLOR,
  FACIAL_HAIR,
  CLOTHING,
  CLOTHES_COLOR,
  EYES,
  EYEBROWS,
  MOUTH,
  SKIN_COLOR,
  ACCESSORIES_COLOR,
} from 'utils/constants/avatarStyles';

function AvatarStyleSelectors() {
  return (
    <SimpleGrid
      minChildWidth={{ base: '100px', md: '150px', lg: '200px', xl: '300px' }}
      width="auto"
      spacing={{ base: '5px', md: '20px' }}
    >
      {/* HAIR COMPONENTS */}
      {/* Hair/Hat Style Selection */}
      <SelectAvatarStyleInput
        name="topType"
        label="Hair Style"
        options={TOP_STYLES}
        placeholder="Select hair style"
      />

      {/* Hair Color Selection */}
      <SelectAvatarStyleInput
        name="hairColor"
        label="Hair Color"
        options={HAIR_COLOR}
        placeholder="Select hair color"
      />

      {/* Facial Hair Selection */}
      <SelectAvatarStyleInput
        name="facialHair"
        label="Facial Hair"
        options={FACIAL_HAIR}
        placeholder="Select facial hair style"
      />

      {/* Facial Hair Color Selection */}
      <SelectAvatarStyleInput
        name="facialHairColor"
        label="Facial Hair Color"
        options={HAIR_COLOR}
        placeholder="Select facial hair color"
      />

      {/* FACE COMPONENTS */}

      {/* Eyes Selection */}
      <SelectAvatarStyleInput
        name="eyes"
        label="Eyes"
        options={EYES}
        placeholder="Select eye expression"
      />

      {/* Eyebrows Selection */}
      <SelectAvatarStyleInput
        name="eyebrows"
        label="Eyebrows"
        options={EYEBROWS}
        placeholder="Select eyebrow style"
      />

      {/* Mouth Selection */}
      <SelectAvatarStyleInput
        name="mouth"
        label="Mouth"
        options={MOUTH}
        placeholder="Select mouth expression"
      />

      {/* BODY COMPONENTS */}

      {/* Clothing Selection */}
      <SelectAvatarStyleInput
        name="clothing"
        label="Clothing"
        options={CLOTHING}
        placeholder="Select clothing style"
      />

      {/* Clothing Color Selection */}
      <SelectAvatarStyleInput
        name="clothingColor"
        label="Clothing Color"
        options={CLOTHES_COLOR}
        placeholder="Select clothing color"
      />

      {/* Skin Color Selection */}
      <SelectAvatarStyleInput
        name="skinColor"
        label="Skin Color"
        options={SKIN_COLOR}
        placeholder="Select skin color"
      />

      {/* Accessories Selection */}
      <SelectAvatarStyleInput
        name="accessories"
        label="Accessories"
        options={ACCESSORIES}
        placeholder="Select accessories"
      />

      {/* Accessories Color Selection */}
      <SelectAvatarStyleInput
        name="accessoriesColor"
        label="Accessories Color"
        options={ACCESSORIES_COLOR}
        placeholder="Select accessories color"
      />
    </SimpleGrid>
  );
}

export default AvatarStyleSelectors;
